import React from 'react';
import moment from 'moment';
import {useQuery} from '@apollo/client';
import Query from '../../components/Query';
import {QUERY_USER} from '../Client/graphql';
import {QUERY_TRANSACTION_LIST} from './graphql';
import {ACTIONS} from './constants';
import Icon from '../../components/Icon';

const TransactionList = () => {
  const {user} = useQuery(QUERY_USER).data;
  const query = useQuery(QUERY_TRANSACTION_LIST);

  return (
    <div className="my-3">
      <div className="alert alert-info align">
        <div className="row align-items-center">
          <div
            className="col-auto"
            style={{
              width: 26,
              height: 26,
              borderRadius: 13,
              background:
                'url(https://cdn6.aptoide.com/imgs/8/4/8/8489241aa54764816306cd56c3659868_icon.png?w=160) center center no-repeat',
              backgroundSize: 'cover',
            }}
          />
          <div className="col-auto ms-2 text-dark">Пополнение баланса</div>
        </div>
        <div className="mt-2">
          Зайдите в мобильное приложение kaspi.kz <Icon name="arrow-right" color="danger" size={18} /> затем в Платежи{' '}
          <Icon name="arrow-right" color="danger" size={18} /> ищем arine.kz{' '}
          <Icon name="arrow-right" color="danger" size={18} /> пополняем на ID:{' '}
          <span className="fw-bold">{('000000' + user.client.id).slice(-6)}</span>
        </div>
        <div className="mt-2">Обработка платежа может занять от 30 мин до 3 часов</div>
      </div>
      {Query(query) || (
        <div className="list-group list-group-flush border rounded bg-white p-0">
          {query.data.transactionList.map(item => (
            <div className="list-group-item p-3" key={item.id}>
              <div className="row align-items-center">
                <div className="col">
                  {item.amount > 0 && '+'}
                  {item.amount} тг.
                </div>
                <div className="col-auto text-end fs-6">
                  <div className="text-uppercase">{ACTIONS[item.action].label}</div>
                  <div className="text-muted">{moment(item.createdAt).format('DD MMM YYYY, HH:mm')}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TransactionList;
